module.exports = __webpack_public_path__ + "img/15-sdg-full@2x.6c507d52.png";